<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="650"
    scrollable
    retain-focus
    :fullscreen="isMobile()"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-show="
          produto.descricao
            .toLowerCase()
            .includes(pesquisaProduto.toLowerCase())
        "
        v-if="isMobile()"
        class="grey lighten-4 mt-3"
        three-line
        v-bind="attrs"
        v-on="on"
      >
        <slot></slot>
      </v-list-item>
      <v-btn
        v-on="on"
        v-bind="attrs"
        depressed
        text
        rounded
        color="info"
        v-else
      >
        <v-icon left>mdi-cart-check</v-icon> Selecionar</v-btn
      >
    </template>
    <v-card>
      <v-card-title
        class="font-weight-bold rounded-0"
        :class="{ 'title white--text primary': isMobile() }"
      >
        {{ produto.descricao }}
      </v-card-title>
      <v-card-subtitle
        class="title"
        :class="{ 'subtitle-1 white--text primary': isMobile() }"
        >{{ produto.embalagem }} ({{ produto.grupo }}-{{ produto.subgrupo }}-{{
          produto.item
        }})</v-card-subtitle
      >
      <v-card-text :class="['cor-fundo']" class="pt-4">
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <card-adicionar-produto-insumos v-else />
      </v-card-text>
      <v-card-actions v-if="produtoSelecionado" :class="{ 'pa-0': isMobile() }">
        <v-row dense>
          <v-col cols="6" :class="{ 'pr-0': isMobile() }">
            <v-btn
              :rounded="!isMobile()"
              :tile="isMobile()"
              color="success"
              :class="{ 'subtitle-1': isMobile() }"
              block
              :depressed="isMobile()"
              @click="addProduto()"
              :height="isMobile() ? 55 : 35"
              :disabled="
                produtoSelecionado.tratamentos.findIndex(
                  (t) => t.cotacoes.length > 0
                ) < 0 || pedido_item.quantidade <= 0
              "
              >Adicionar Produto</v-btn
            >
          </v-col>
          <v-col cols="6" :class="{ 'pl-0': isMobile() }">
            <v-btn
              @click="dialog = false"
              block
              :tile="isMobile()"
              :rounded="!isMobile()"
              class="secondary"
              :class="{
                'subtitle-1': isMobile(),
              }"
              :dark="isMobile()"
              :height="isMobile() ? 55 : 35"
              :depressed="isMobile()"
              >Cancelar</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import CardAdicionarProdutoInsumos from "../cards/CardAdicionarProdutoInsumos.vue";
export default {
  components: { CardAdicionarProdutoInsumos },
  props: {
    produto: { type: Object, required: true },
  },
  computed: {
    ...mapState("insumos", [
      "produtoSelecionado",
      "pedido_item",
      "pesquisaProduto",
    ]),
  },
  watch: {
    dialog: async function (open) {
      if (open) {
        this.setProdutoSelecionado(this.produto);
        if (navigator.onLine) {
          this.loading = true;
          await this.getCotacoesOnline();
        }
        this.loading = false;
      }
    },
  },
  data: () => ({
    dialog: false,
    loading: true,
  }),
  methods: {
    ...mapMutations("insumos", [
      "setDialogProdInsumos",
      "setProdutoSelecionado",
    ]),
    ...mapActions("insumos", ["adicionarProduto", "getCotacoesOnline"]),
    ...mapMutations("insumos", ["setLoadingPedido", "setListaItens"]),
    isMobile() {
      return this.$mq == "sm";
    },
    addProduto() {
      if (this.pedido_item.quantidade <= 0 || this.pedido_item.quantidade >= 9999) {
        this.$toasted.error("Quantidade inválida!", {
          position: this.isMobile() ? "bottom-center" : "top-center",
        });
        return;
      } else if (
        this.pedido_item.quantidade > this.pedido_item.saldo_disponivel
      ) {
        this.$toasted.error(
          "Quantidade informada é maior que o saldo disponível!",
          { position: this.isMobile() ? "bottom-center" : "top-center" }
        );
        return;
      }
      this.$store.state.insumos.adicionandoProduto = true;
      this.setDialogProdInsumos(false);
      this.dialog = false;
      this.adicionarProduto();
      this.setListaItens();
      this.$store.state.insumos.adicionandoProduto = false;
      //this.$router.go();
    },
  },
};
</script>

<style>
</style>